export * from './site-master-list.graphql';
export * from './service-master-list.graphql';
export * from './language-list.graphql';
export * from './qualtrics-survey-feedback-details.graphql';
